import { Component, OnInit, ViewChild, ElementRef, HostListener, SecurityContext } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { NgbModal, NgbModalOptions , NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { OAuthService } from 'angular-oauth2-oidc';
import { CookieService } from 'ngx-cookie-service';
import { NgxSpinnerService } from 'ngx-spinner';
import { environment } from '../../environments/environment';
import { CommonModule, PlatformLocation } from '@angular/common';
import { NavigationStart, Router,ActivatedRoute, RouterLink} from '@angular/router';
import * as $ from 'jquery';
import { UserAuthService } from '../services/user-auth.service';
import { CampaignService } from '../services/campaign.service';
import { DomSanitizer } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { HtmlSafePipe } from '../helpers/pipe/html-safe.pipe';
import { Guid } from 'guid-typescript';
import { LogoComponent } from "../logo/logo.component";

@Component({
  selector: 'app-security-question',
  templateUrl: './security-question.component.html',
  styleUrls: ['./security-question.component.css'],
  host: {'class': 'ipadfooterbottom'},
  standalone: true,
  imports: [HtmlSafePipe,
    CommonModule,
    RouterLink, LogoComponent]
})

export class SecurityQuestionComponent implements OnInit {
  @ViewChild('backButtonError', { static: false,  }) backButtonError: ElementRef;
  userData = null;
  modalOptions: NgbModalOptions;
  securityQuestionList = [];
  errorMsg = ''; securityQuestionErrorMsg = '';
  securityQuestionAttempt = 1;
  successMsg = '';
  time: any;
  securityQuestion: any;
  securityAnswer: {} = {};
  questionIndex=0;
  totalQuestion=5;
  correctAnswarId=0;
  isActivePrevNext=false;
  isbuttonSubmit=false;
  isDefalutMessage=true;
  WebSource = '';
  isHidden: boolean =true ;
  internalServerErrorMessage = 'A technical error has occurred. Please contact us on:+27 860061058, for assistance with completing your registration.';
  IsBureauDown = false;
  allowForAnotherPage = false;
  isSolJourney = false;
  private isModalOpen = false;
  private lastActivityTime = Date.now();
  currentYear = new Date().getFullYear();
  signupSuccess = false;
  campaignCookieName: string="user_campaign";
  sapiEmbededUrl = '';
  messages: any[] = [];
  subscription: Subscription | null = null;
  sapi=["Sapi In NgOnit","Sapi Embeded before if", "Sapi Embeded in if","Sapi Return URL received", "Sapi in SecuityQuestions if with SQ", "Before redirecing to login"];


  constructor(
    private readonly spinner: NgxSpinnerService,
    private readonly cookieService: CookieService,
    private readonly oauthService: OAuthService,
    private readonly location: PlatformLocation,
    private readonly  router: Router,
    config: NgbModalConfig,
    private readonly  modalService: NgbModal,
    private readonly userAuthService : UserAuthService,
    private readonly activatedRoute: ActivatedRoute,
    private readonly campaignService:CampaignService,
    private readonly sanitizer: DomSanitizer,
    )  {
      config.backdrop = 'static';
      config.keyboard = false;
      history.pushState(null, null, globalThis.location.href);
      this.location.onPopState(() => {
        this.isDefalutMessage = false;
        if (this.allowForAnotherPage == false) {
          history.pushState(null, null, globalThis.location.href);
          this.openNavigationWarning();
        }
      });
      router.events
      .subscribe((event: NavigationStart) => {
        if (event.navigationTrigger == "popstate") {
          history.pushState(null, null, location.href);
          const currentRoute = this.router.routerState;
          this.router.navigateByUrl(currentRoute.snapshot.url, { skipLocationChange: true });
          this.openNavigationWarning();
          this.isDefalutMessage = false;
        }
        if (event.navigationTrigger == 'imperative' && event.url == '/register' && !localStorage.getItem('SolRegisterUrl')) {
          const currentRoute = this.router.routerState;
          this.router.navigateByUrl(currentRoute.snapshot.url, { skipLocationChange: true });
          this.openNavigationWarning();
          this.isDefalutMessage = false;
        }
      });

    }


  @HostListener('window:mousemove') onMouseMove() { this.lastActivityTime = Date.now(); }
  @HostListener('window:keydown') onKeyDown() { this.lastActivityTime = Date.now(); }
  @HostListener('window:click') onWindowClick() { this.lastActivityTime = Date.now(); }
  @HostListener('window:blur') onWindowBlur() { this.lastActivityTime = Date.now(); }

  @HostListener('window:beforeunload', ['$event'])
    beforeunload(event: any) {
      const loginFired = localStorage.getItem('loginFired');
      if (this.isDefalutMessage && loginFired !== 'true') {
        console.log(this.router);
        event.preventDefault();
        event.returnValue = '';
        return false;
      }
      localStorage.removeItem('loginFired');
    }

  ngOnInit() {
    this.isSolJourney = !!localStorage.getItem('SolRegisterUrl');

    if (!this.userAuthService.isSolUser()) {
      this.userAuthService.logoutActiveUser(globalThis.location.origin + '/register');
    }
    console.table(this.sapi[0]);
    this.embedIframeFromSapi();

    this.activatedRoute.queryParams.subscribe(params => {
      if (params && (params.websource || params.WebSource || params.webSource)) {
        this.WebSource = params.websource || params.WebSource || params.webSource;
      }
    });

    this.addBodyClass();
    this.autoResize();
    this.noScrollBody();
  }

  embedIframeFromSapi()
  {
    console.table(this.sapi[1]);
    this.spinner.show();
    const sp = localStorage.getItem('SapiVisitUrl');
    if (sp == null) {
      this.spinner.hide();
      localStorage.setItem('errorMsg', 'Security questions verification failed. A coach will call you shortly to assist.');
      this.removeLocalStorage();
      this.isDefalutMessage = false;
      this.redirectToLogoutWithError();
      return;
    }
    if(sp != null)
    {
      console.table(this.sapi[2]);
      this.sapiEmbededUrl = this.sanitizer.sanitize(SecurityContext.URL, sp) || '';
      console.table(
       {
          Message: this.sapi[2],
          SanitizedURL: this.sapiEmbededUrl
       }
      );
      this.spinner.hide();
      globalThis.addEventListener('message', (event) => {

        const eventData = event.data;

        if(eventData != null || eventData != undefined) {
          this.isDefalutMessage = false;

          if (typeof eventData === 'string' && eventData.includes('sq-redirect')) {
              setTimeout(() => {
                this.redirectToHomeAfterSqSuccess();
              }, 2000);
              return;
          }
        }


        if(eventData != undefined && eventData =='process-failed')
        {
          this.isDefalutMessage=false;
          this.removeLocalStorage();
          localStorage.removeItem('SapiVisitUrl');
          const solUrl = localStorage.getItem('SolRegisterUrl');
          if (solUrl) {
            localStorage.removeItem('SolRegisterUrl');
            setTimeout(() => {
              localStorage.setItem('sqFailed', 'true');
              globalThis.location.href = solUrl + '?isActive=0';
            }, 5000);
          } else {
            localStorage.setItem('errorMsg', 'Security questions verification failed. A coach will call you shortly to assist.');
            this.redirectToLogoutWithError();
          }
        }

        if(eventData != undefined && eventData =='session-timeout')
        {
          const idleMs = Date.now() - this.lastActivityTime;
          const idleThresholdMs = 3 * 60 * 1000;
          if (idleMs < idleThresholdMs) {
            return;
          }
          localStorage.setItem('sapiValidateSecurityQuestion', 'true');
          localStorage.setItem('errorMsg', "Your session has timed out and your registration couldn't be completed. A coach will call you shortly.");
          localStorage.removeItem('SapiVisitUrl');
          this.isDefalutMessage = false;
          setTimeout(()=>{
            this.hideSecurityQuestion();
          }, 5000);
        }
      });
    }

  }




  noScrollBody() {
    const bodyTag = document.body;
    bodyTag.classList.add('noscroll');
  }
  autoResize() {
    const windowh = $(window).height();
    const header = $('.header-hld').height() + 45;
    const desiredHeight = windowh - header;
    $('iframe').css("min-height", desiredHeight + 'px');
  }
  private openNavigationWarning(): void {
    if (this.isModalOpen) { return; }
    this.isModalOpen = true;
    this.modalService.open(this.backButtonError, this.modalOptions).result.finally(() => {
      this.isModalOpen = false;
    });
  }

  stopNavigation()
  {
    this.modalService.dismissAll();
    this.isDefalutMessage=true;
  }

  securitycontainerHeight(){
    const windowh = $(window).height();
    const desiredHeight = windowh;
    $('.min-h').css("min-height", desiredHeight + 'px');
  }
  onResize(ev) {
    this.securitycontainerHeight();
    this.autoResize();
  }




  doNavigation()
  {
   this.modalService.dismissAll();
   const registerUrl=localStorage.getItem('RegisterUrl');
   const SPLregisterUrl=localStorage.getItem('SplRegiterUrl');
   const HLregisterUrl=localStorage.getItem('HLRegisterUrl');
   const branchregistration=localStorage.getItem('BranchRegisterUrl');
   const solRegisterUrl=localStorage.getItem('SolRegisterUrl');
   this.removeLocalStorage();

   if(solRegisterUrl !=null)
     {
      localStorage.removeItem('SolRegisterUrl');
      globalThis.location.href = solRegisterUrl + '?isActive=0';
      return;
     }

   if(registerUrl !=null)
     {
      if(this.WebSource){
        globalThis.location.href = '/register?websource=' + this.WebSource;
       }
       else{
        globalThis.location.href = registerUrl;
       }
     }
     if(SPLregisterUrl !=null)
     {
      if(this.WebSource){
        globalThis.location.href = '/spl-registration?websource=' + this.WebSource;
      }
      else{
        globalThis.location.href = '/spl-registration';
      }

     }
     if(HLregisterUrl !=null)
     {
      if(this.WebSource){
        globalThis.location.href = '/hl-registration?websource=' + this.WebSource;
      }
      else{
        globalThis.location.href = '/hl-registration';
      }

     }

     if(branchregistration !=null)
     {
        globalThis.location.href = branchregistration;

     }

  }

  securityQuestionVerficationFailed() {
    this.hideSecurityQuestion();
  }


  login() {
    this.isDefalutMessage=false;
    localStorage.removeItem('loginFired');
    localStorage.removeItem('SapiVisitUrl');
    this.spinner.show();
    this.azureAdlogin(true);
  }
 azureAdlogin(isRegistrationSuccess: boolean) {
  setTimeout(() => {
    this.spinner.show();
   }, 50);
    localStorage.removeItem('tempToken');
    let submissionId = '';
    let submissionCode = Guid.create().toString();
    if (this.cookieService.get('submissionId')) {
      submissionId = this.cookieService.get('submissionId');
    }

    if (isRegistrationSuccess) {
      submissionCode = '0df6b091-5d71-4f75-a6df-2d6a016e3709';
    }

    Guid.create().toString()

    let campaignCookie = this.cookieService.get(this.campaignCookieName);
    if (campaignCookie && campaignCookie !== '') {
      this.campaignService.getActiveCampaign("", campaignCookie).subscribe((data: any) => {
        this.oauthService.initLoginFlow('', {
          submissionId, ccAppUrl: globalThis.location.origin, submissionCode,
          instrumentationKey: environment.appInsights.instrumentationKey,
          utm_id: data.campaignUtmId
        });
      }, (err: HttpErrorResponse) => console.log(err));

    }
    else {
      this.oauthService.initLoginFlow('', {
        submissionId, ccAppUrl: globalThis.location.origin, submissionCode,
        instrumentationKey: environment.appInsights.instrumentationKey
      });
    }
  }
  hideSecurityQuestion(){
   this.isDefalutMessage=false;

   localStorage.removeItem('loginFired');
   this.doNavigation();
  }

  startTimeOut() {
    globalThis.onload = () => {
      this.resetTimer();
    };

    document.onmousemove = () => {
      this.resetTimer();
    };

  }

  resetTimer() {
    if (this.time !== 'stop') {
      console.log('no Idle');
      clearTimeout(this.time);
      this.time = setTimeout(() => {
        console.log('timeout');
        this.modalService.dismissAll();
        localStorage.removeItem('OnLoadCheck');
        localStorage.removeItem('tempToken');
        this.errorMsg = 'Your session has timed-out and your registration could not be completed.';
        localStorage.setItem('errorMsg', this.errorMsg);

        this.securityQuestionVerficationFailed();

      }, 3 * 60 * 1000);
    }
  }

  stopTimer() {
    clearTimeout(this.time);
    this.time = 'stop';
    console.log('Timer Stop');
    console.log(this.time);
  }
  removeLocalStorage() {
    localStorage.removeItem('OnLoadCheck');
    localStorage.removeItem('tempToken');
  }

  private redirectToLogoutWithError(): void {
    this.isDefalutMessage = false;
    localStorage.removeItem('loginFired');
    localStorage.removeItem('SapiVisitUrl');
    const errorMsg = encodeURIComponent(localStorage.getItem('errorMsg') || 'Security questions verification failed. A coach will call you shortly to assist.');
    globalThis.location.href = globalThis.location.origin + '/login?error=' + errorMsg;
  }

  private redirectToHomeAfterSqSuccess(): void {
    this.isDefalutMessage = false;
    localStorage.removeItem('loginFired');
    localStorage.removeItem('SapiVisitUrl');
    localStorage.removeItem('OnLoadCheck');
    localStorage.removeItem('tempToken');
    this.router.navigateByUrl('/portal/home');
  }


  addBodyClass() {
    const bodyTag = document.body;
    bodyTag.classList.add('pt-2');
  }
}
